import React from "react";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import { Link } from "react-router-dom";

export default class WorkdocStructure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      structureSelected: [],
      structureExpanded: [],
    };
  }

  componentDidMount() {
    this.treeRestoreExpanded(this.props.structureId);
  }

  treeGetPath = (id) => {
    let result = [];
    const items = this.props.items;
    if (id && Object.keys(items).length > 0) {
      if (items[`_${id}`]) {
        let parentNodeId = items[`_${id}`].node;
        result = [String(id)];
        while (parentNodeId) {
          result.push(String(parentNodeId));
          parentNodeId = items[`_${parentNodeId}`].node;
        }
      }
    }
    return result.reverse();
  };
  treeRestoreExpanded = (id) => {
    if (!id) {
      this.setState({ structureExpanded: [], structureSelected: [] });
    } else {
      const expanded = this.treeGetPath(id);
      this.setState({ structureExpanded: expanded, structureSelected: id });
    }
  };

  treeHandleToggle = (event, nodeIds) => {
    this.setState({ structureExpanded: nodeIds, structureSelected: [] });
  };
  treeHandleSelect = (event, nodeIds) => {
    this.setState({ structureSelected: nodeIds });
  };

  getChildren = (itemId) => {
    let children = [];
    for (let id in this.props.items) {
      let item = this.props.items[id];
      if (item.node === itemId) children.push(item);
    }
    return children;
  };

  render() {
    const renderTree = (item) => (
      <TreeItem
        onClick={(e) => e.preventDefault()}
        key={item.id}
        nodeId={String(item.id)}
        label={
          <>
            <Link
              className="d-block py-1 text-dark"
              to={`/workdoc/${this.props.listMode}/${item.id}/`}
            >
              {item.label}
            </Link>
          </>
        }
        className="my-2"
        onLabelClick={(e) => e.preventDefault()}
      >
        {this.getChildren(item.id).map((item) => renderTree(item))}
      </TreeItem>
    );

    return (
      <>
        <TreeView
          defaultCollapseIcon={<i className="fa fa-angle-down"></i>}
          defaultExpandIcon={<i className="fa fa-angle-right"></i>}
          expanded={this.state.structureExpanded}
          selected={this.state.structureSelected}
          onNodeToggle={this.treeHandleToggle}
          onNodeSelect={this.treeHandleSelect}
        >
          {Object.entries(this.props.items).map(([id, item]) =>
            !item.node ? renderTree(item) : null
          )}
        </TreeView>
      </>
    );
  }
}
